module.exports = __webpack_public_path__ + "static/3xsafe-desktop-a14e75d47bd9d7644b423b59c27e88f5.png";